// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7.esm.bundle.js';
// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';

// Import App Component
import App from '../components/app.vue';
import store from "../pages/store/store";
import { mixin } from "../js/mixin";
import lodash from 'lodash';
import moment from "moment";
import $ from 'dom7';
import loginScreen from 'framework7-vue/components/login-screen';
import firebase from 'firebase'

Vue.prototype.moment = moment;
// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue, lodash);


//let user = null
let newapp = null
console.log("Yess,,,,,,,,,,,,,,,,,,,,,,")
//store.commit('setSignedIn', false)





if (!newapp) {
  newapp = // Init App
    new Vue({
      el: '#app',
      render: (h) => h(App),
      store,
      // Register App Component
      components: {
        app: App
      },
      on: {
        init: function showToastBottom1(text) {
          // add toast function here
          // console.log("hello alert")
          //app.dialog.confirm('Are you feel good today?', function () {
          //app.dialog.alert('Great!');
          //  });


        }// end of showToastBottom
      }
    });
}

function checkUserStatus(user) {

  console.log("No,,,,,,,,,,,,,,,,,,,,,,")
  if (user != null) {

    if (user.emailVerified) {
      // var user_id = firebase.auth().currentUser.uid
      //firebase.database().ref('users').child(user_id)
      // .once('value', snapshot => {
      store.commit('setSignedIn', true)
      store.commit('setDisplayName', user.displayName)
      store.commit('setPhotoURL', user.photoURL)
      store.commit('setUserLocation', user.location)
      store.commit('setUserPageSize', user.pageSize)
      store.commit('setProfileMessage', user.profileMessage)

      //call axious to update user online
      //  userStatus: "online",
      //  lastSeen: firebase.database.ServerValue.TIMESTAMP
      // this is offline
      //userStatus: "offline",
      //lastSeen: firebase.database.ServerValue.TIMESTAMP





    } else {
      // No user is signed in.
      store.commit('setSignedIn', false)

    }





  } else {
    console.log("this check here")
  }

  Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })

  Vue.filter('emptyReplace', function (value) {
    if (!value) return ''
    value = value.toString()
    value = value.replace('<b>', '')
    value = alue.replace('</b>', '')
    return value
  })


  if (!newapp) {
    newapp = // Init App
      new Vue({
        el: '#app',
        render: (h) => h(App),
        store,
        // Register App Component
        components: {
          app: App
        },
        on: {
          init: function showToastBottom1(text) {
            // add toast function here
            // console.log("hello alert")
            //app.dialog.confirm('Are you feel good today?', function () {
            //app.dialog.alert('Great!');
            //  });


          }// end of showToastBottom
        }
      });
  }


}




var isAppForeground = true;

// document.addEventListener('deviceready', pushNotification, false);


var opened = 0;
function exitApp() {
  //console.log("hello am here")
  if (opened > 0) {
    return false;
  } else {
    app.dialog.confirm('Are you sure you want to exit?', 'Exit App',
      function () {
        navigator.app.exitApp();
      },
      function () {
        opened = 0;
        return false;
      }
    );
    opened = 1;
  }
}

function getOS() {
  // console.log("getos");
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

//if (getOS() == "Android" || getOS() == "iOS") {
if (window.hasOwnProperty("cordova")) {
  var admobid = {};

  // TODO: replace the following ad units with your own
  if (/(android)/i.test(navigator.userAgent)) {
    admobid = { // for Android
      banner: 'ca-app-pub-3672658228483041/1188268714',
      //interstitial: 'ca-app-pub-3940256099942544/1033173712',
      //rewardvideo: 'ca-app-pub-3940256099942544/5224354917',
    };
  } else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent)) {
    admobid = { // for iOS
      banner: 'ca-app-pub-3672658228483041/1188268714',
      //interstitial: 'ca-app-pub-3940256099942544/4411468910',
      //rewardvideo: 'ca-app-pub-3940256099942544/1712485313',
    };
  } else {
    admobid = { // for Windows Phone, deprecated
      banner: 'ca-app-pub-3672658228483041/1188268714',
      //interstitial: '',
      //rewardvideo: '',
    };
  }

  function initApp() {
    if (!AdMob) { alert('admob plugin not ready'); return; }
    // console.log("nosa", admobid.banner)
    // this will create a banner on startup
    AdMob.createBanner({
      adId: admobid.banner,
      position: AdMob.AD_POSITION.BOTTOM_CENTER,
      //isTesting: false, // TODO: remove this line when release
      overlap: false,
      offsetTopBar: false,
      autoShow: true,
      bgColor: 'black'
    });
    //admob.banner.prepare()
    // this will load a full screen ad on startup
    // AdMob.prepareInterstitial({
    // adId: admobid.interstitial,
    //isTesting: true, // TODO: remove this line when release
    //     autoShow: false
    // });
  }

  // if ((/(ipad|iphone|ipod|android|windows phone)/i.test(navigator.userAgent))) {
  if (window.hasOwnProperty("cordova")) {
    document.addEventListener('deviceready', initApp, false);
  } else {
    initApp();
  }





  document.addEventListener('deviceready', function () {
    //console.log("deviceReady")
    //var user_id = firebase.auth().currentUser.uid
    // Enable to debug issues.
    // window.plugins.OneSignal.setLogLevel({logLevel: 4, visualLevel: 4});

    var notificationOpenedCallback = function (jsonData) {
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
    };

    window.plugins.OneSignal
      .startInit("41eb99ce-3675-452f-a747-613986dcdf01")
      .handleNotificationOpened(notificationOpenedCallback)
      .inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification)
      .endInit();





    document.addEventListener("offline", onOffline, false);
    document.addEventListener("backbutton", onBackKeyDown, false);


    function onOffline() {
      // Handle the offline event
      store.commit('setAlertMessage', "It seems you are offline. Kindly check internet connection to continue...")
    }

    function onBackKeyDown() {
      store.commit('setQuitApplication', "1")
    }

    var opened = 0;
    function exitApp() {
      const app = this.$
      //console.log("hello am here")
      if (opened > 0) {
        return false;
      } else {
        app.dialog.confirm('Are you sure you want to exit?', 'Exit App',
          function () {
            navigator.app.exitApp();
          },
          function () {
            opened = 0;
            return false;
          }
        );
        opened = 1;
      }
    }


    cordova.plugins.firebase.messaging.getBadge().then(function (value) {
      //console.log("Badge value: ", value);
      cordova.plugins.firebase.messaging.setBadge(value++);
      //cordova.plugins.firebase.messaging.setBadge(100);
    });
    cordova.plugins.firebase.messaging.setBadge(100);

    cordova.plugins.firebase.messaging.onBackgroundMessage(function (payload) {
      //console.log("New background FCM message: ", JSON.stringify(payload));
    });


  })

}


